/**
 * URL query parameter names for the Index listing page (`/index`).
 * Use these instead of string literals so links and filters stay consistent.
 */
export const INDEX_PAGE_QUERY_ASSET_CLASS = "asset_class" as const;

/** Canonical param for Index Family filter (shareable URLs). */
export const INDEX_PAGE_QUERY_INDEX_FAMILY = "index_family" as const;

/**
 * Legacy param for Index Family (older URLs / breadcrumbs).
 * Prefer {@link INDEX_PAGE_QUERY_INDEX_FAMILY} for new links.
 */
export const INDEX_PAGE_QUERY_INDEX_TYPE_LEGACY = "index_type" as const;
